import Vue from 'vue'
import VueRouter from 'vue-router'
import zhUser from '@/views/zhUser.vue';
import zhPrivacy from '@/views/zhPrivacy.vue';
import enUser from '@/views/enUser.vue';
import enPrivacy from '@/views/enPrivacy.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/enUserProtocol',
		component: enUser,
		meta: {
			title: 'DV Link User Agreement'
		}
	},
    {
		path: '/enUserProtocol',
		name: 'enUserProtocol',
		component: enUser,
		meta: {
			title: 'DV Link User Agreement'
		}
	},
	{
		path: '/enPrivacy',
		name: 'enPrivacy',
		component: enPrivacy,
		meta: {
			title: 'DV Link Privacy Policy'
		}
	},
	{
		path: '/userProtocol',
		name: 'userProtocol',
		component: zhUser,
		meta: {
			title: 'DV Link 用户协议'
		}
	},
	{
		path: '/Privacy',
		name: 'Privacy',
		component: zhPrivacy,
		meta: {
			title: 'DV Link 隐私政策'
		}
	}
]

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	console.log(to.meta.title)
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
})
export default router
